<template>
    <div class="side-bar">
        <div class="subtitle flex-align-between">
            <h2 class="text f16 flex-align">近期聚焦</h2>
            <!-- <button class="more f12">查看更多 &gt;</button> -->
        </div>
        <ul class="day-lists">
            <li class="flex-align" v-for="(li, index) in days" :key="index">
            <div class="day f12 flex-column">
                <span class="f28">{{li.day}}</span><span>{{li.month}}</span>
            </div>
            <div class="describe">
                <h3 class="title wes">{{li.title}}</h3>
                <span class="eye f12">{{li.lookNum}}</span>
            </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
             days:[{
                day:'25',
                month:'Apr',
                title:'【要点串烧】理论讲堂-教育信息化2.0教育教育',
                lookNum:'1273'
            },{
                day:'25',
                month:'Apr',
                title:'【要点串烧】理论讲堂-教育信息化2.0教育教育',
                lookNum:'1273'
            },{
                day:'25',
                month:'Apr',
                title:'【要点串烧】理论讲堂-教育信息化2.0教育教育',
                lookNum:'1273'
            }]
        }
    }
}
</script>

<style lang="less" socped>
    .side-bar {
        width: 364px;

        .subtitle {
        padding: 0 22px;
        border-bottom: 1px dashed #004098;
        height: 60px;
        
        color: #1c4b90;

        .text::before {
            content: ' ';
            display: inline-block;
    
            margin-right: 11px;
            width: 20px;
            height: 20px;

            background-image: url("../../../../static/news/recent@2x.png");
        }
    }

        .day-lists {
            padding-top: 38px;
            
            li {
                margin-bottom: 20px;
            }

            .day {
                position: relative;

                margin-right: 17px;
                padding: 10px 0; 
                width: 66px;

                color: #fff;
                background-color: #54A5D8;
                text-align: center;
                line-height: 1;

                span:first-child {
                    margin-bottom: 6px;
                }

                &::after {
                    content: ' ';
                    
                    position: absolute;
                    right: -6px;
                    top: 6px;

                    width: 6px;
                    height: 54px;

                    background-color: #BEE3FF;
                }
            }

            .describe {
                .title {
                    margin-bottom: 13px;
                    max-width: 257px;
                }

                .eye {
                    color: #999;
                }
                .eye::before {
                    content: ' ';
                    display: inline-block;
        
                    margin-right: 4px;
                    width: 16px;
                    height: 12px;
                    background-repeat: no-repeat;
                }

                .eye::before {
                    background-image: url("../../../../static/news/eye@2x.png");
                    background-size: 16px 17px;
                }
            }
        }
        
        .f28 {
        font-size: 28px;
        }
    }
</style>